'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidBus = function IoAndroidBus(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm6 27.5v-15.9c0-5.9 6.4-6.6 13.8-6.6s13.7 0.7 13.7 6.6v15.9c0 1.4-1.1 1.9-2.1 2.8v3.1c0 0.9-0.7 1.6-1.6 1.6h-1.7c-0.9 0-1.7-0.7-1.7-1.6v-1.8h-13.3v1.8c0 0.9-0.8 1.6-1.7 1.6h-1.6c-1 0-1.7-0.7-1.7-1.6v-3.1c-1-0.9-2.1-1.3-2.1-2.8z m6.3 1.3c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1-2.5 2.5 1 2.5 2.5 2.5z m15 0c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1-2.5 2.5 1 2.5 2.5 2.5z m2.5-9.7v-8.2h-20v8.2h20z' })
        )
    );
};

exports.default = IoAndroidBus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-bus.js
// module id = 2060
// module chunks = 0